export const endpoints = {
  signin: 'auth/login/local',
  loginCheck: 'auth/login/check',
  signup: 'auth/registration',
  checkAuthentication: 'auth/check',
  saveUserInfo: 'auth/onboard',
  magicVerify: 'auth/login/magic',
  sendMagicLink: 'auth/login/send',
  magicLogin: 'auth/magic/login',
  forgotPassword: 'auth/forgot',
  resetPassword: 'auth/reset',
  getEmail: {
    urlCode: '',
    get url(): string {
      return `/auth/email/${this.urlCode}`;
    },
  },
  imageUpload: {
    get url(): string {
      return '/file';
    },
  },

  dashboard: {
    r_start: 0,
    r_limit: 0,
    kl_start: 0,
    kl_limit: 0,
    kd_start: 0,
    kd_limit: 0,
    get url(): string {
      return `dashboard?r_start=${this.r_start}&r_limit=${this.r_limit}&kl_start=${this.kl_start}&kl_limit=${this.kl_limit}&kd_start=${this.kd_start}&kd_limit=${this.kd_limit}`;
    },
  },
  learning: {
    lesson_slug: '',
    next: '',
    next_type: '',
    share_id: '',
    get url(): string {
      return `learn?lesson_slug=${this.lesson_slug}&next=${this.next}&next_type=${this.next_type}&share_id=${this.share_id}`;
    },
  },

  learnQuizCheck: 'learn/check',
  completeLearning: 'learn/complete',
  learningFeedback: 'learn/feedback',
  learningSurvey: 'learn/survey',
  catalog: {
    start_page: 0,
    limit_page: 0,
    limit_card: 0,
    start_card: 0,
    hide_my_lessons: 1,
    search: '',
    get url(): string {
      return `catalog?start_page=${this.start_page}&search=${this.search}&limit_page=${this.limit_page}&limit_card=${this.limit_card}&hide_my_lessons=${this.hide_my_lessons}`;
    },
  },
  category: {
    slug: '',
    start_page: 0,
    limit_page: 0,
    get url(): string {
      return `catalog/category?slug=${this.slug}&start_page=${this.start_page}&limit_page=${this.limit_page}`;
    },
  },
  myLessons: {
    filter: 'in_progress',
    page: 0,
    pageSize: 6,
    sort: 'a-z',
    get url(): string {
      return `/lesson/mylessons?filter=${this.filter}&page=${this.page}&pageSize=${this.pageSize}&sort=${this.sort}`;
    },
  },
  categories: {},
  lessonOverview: 'lesson',
  bookmarkedLessons: {
    start: 0,
    limit: 0,
    get url(): string {
      return `/bookmark?start=${this.start}&limit=${this.limit}`;
    },
  },
  bookmarkedCards: {
    start: 0,
    limit: 0,
    slug: '',
    get url(): string {
      return `/bookmark/cards?slug=${this.slug}&start=${this.start}&limit=${this.limit}`;
    },
  },
  creations: {
    mode: '',
    filter: '',
    sort: '',
    page: 0,
    itemLimit: 5,
    get url(): string {
      return `/creation?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&start=${this.page}&limit=${this.itemLimit}`;
    },
  },
  creationsByLesson: {
    slug: '',
    start: 0,
    limit: 4,
    get url(): string {
      return `/creation/lesson?slug=${this.slug}&start=${this.start}&limit=${this.limit}`;
    },
  },
  creationById: {
    id: '',
    get url(): string {
      return `/creation/get/${this.id}`;
    },
  },
  creationTaskProgress: {
    get url(): string {
      return `/creation/task/progress`;
    },
  },
  creationTaskAssign: {
    get url(): string {
      return `/creation/task/assign`;
    },
  },
  docById: {
    id: '',
    get url(): string {
      return `/creation/get/${this.id}`;
    },
  },
  createNewCreations: {
    lessonSlug: '',
    get url(): string {
      return `/creation/start?lesson=${this.lessonSlug}`;
    },
  },
  creationAi: {
    get url(): string {
      return 'creation/ai';
    },
  },
  createUser: {
    get url(): string {
      return 'auth/registration';
    },
  },
  getUsers: {
    get url(): string {
      return 'user/members';
    },
  },
  signupQueries: {
    get url(): string {
      return '/user/signup/queries';
    },
  },
  settings: {
    preferences: {
      get url(): string {
        return 'settings/preferences';
      },
    },
    profile: {
      get url(): string {
        return `/settings/profile`;
      },
    },
    changePassword: {
      oldPassword: '',
      newPassword: '',
      get url(): string {
        return `/settings/password`;
      },
    },
    changeEmail: {
      get url(): string {
        return `/settings/email`;
      },
    },
    account: {
      get url(): string {
        return `/settings/account`;
      },
    },
    deleteAccount: {
      get url(): string {
        return `/settings/account/delete`;
      },
    },
    get url(): string {
      return '/settings';
    },
    removeMember: {
      id: '',
      get url(): string {
        return `/settings/member?id=${this.id}`;
      },
    },

    updateMember: {
      get url(): string {
        return '/settings/member';
      },
    },
    updateOrganisation: {
      get url(): string {
        return '/settings/organisation';
      },
    },
    updateOrganisationImage: {
      get url(): string {
        return '/settings/organisation/avatar';
      },
    },
    leaveOrganisation: {
      get url(): string {
        return '/settings/leave';
      },
    },
    availability: {
      get url(): string {
        return '/settings/availability';
      },
    },
  },
  recommendModules: {
    lessonSlug: '',
    get url(): string {
      return `/creation/modules?slug=${this.lessonSlug}`;
    },
  },

  referLessonCards: {
    lessonSlug: '',
    get url(): string {
      return `/lesson/cards/all?slug=${this.lessonSlug}`;
    },
  },

  modules: {
    get url(): string {
      return '/lesson/save';
    },
  },

  search: {
    get url(): string {
      return `search`;
    },
    get save(): string {
      return '/search';
    },
    get recent(): string {
      return '/search/recent';
    },
    get filesearchurl(): string {
      return '/search/files';
    },
    get filesearchsave(): string {
      return '/search/files';
    },
    get filesearchrecent(): string {
      return '/search/recent/files';
    },
  },

  creationTask: {
    get url(): string {
      return '/creation/task';
    },
  },

  deleteTask: {
    get url(): string {
      return '/creation/task/delete';
    },
  },

  creationComment: {
    get url(): string {
      return '/creation/task/comment';
    },
  },

  creationFile: {
    get url(): string {
      return '/creation/file';
    },
  },

  notifications: {
    page: 0,
    limit: 20,
    get url(): string {
      return `user/notifications?page=${this.page}&limit=${this.limit}`;
    },
    get count(): string {
      return `user/notifications/count`;
    },
    get markAsRead(): string {
      return `user/notifications`;
    },
  },

  readNotificationAll: {
    get url(): string {
      return '/user/notifications/all';
    },
  },
  boards: {
    mode: '',
    filter: '',
    sort: '',
    page: 0,
    itemLimit: 5,
    workspace: '',
    get url(): string {
      return this.workspace
        ? `/board?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&start=${this.page}&limit=${this.itemLimit}&workspace=${this.workspace}`
        : `/board?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&start=${this.page}&limit=${this.itemLimit}`;
    },
  },
  files: {
    mode: '',
    filter: '',
    sort: '',
    page: 0,
    itemLimit: 20,
    workspace: '',
    search: '',
    get url(): string {
      const searchQuery = this.search === '' ? '' : `&search=${this.search}`;
      return this.workspace
        ? `/files?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&page=${this.page}&limit=${this.itemLimit}&workspace=${this.workspace}${searchQuery}`
        : `/files?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&page=${this.page}&limit=${this.itemLimit}${searchQuery}`;
    },
  },
  lessons: {
    state: '',
    limit: 20,
    page: 0,
    sort: '',
    workspace: '',
    get url(): string {
      return `/lms/lesson?state=${this.state}&sort=${this.sort}&page=${this.page}&limit=${this.limit}`;
    },
  },
  boardFiles: {
    mode: '',
    filter: '',
    sort: '',
    page: 0,
    itemLimit: 20,
    workspace: '',
    get url(): string {
      return this.workspace
        ? `/files/task?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&page=${this.page}&limit=${this.itemLimit}&workspace=${this.workspace}`
        : `/files/task?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&page=${this.page}&limit=${this.itemLimit}`;
    },
  },

  docs: {
    mode: '',
    filter: '',
    sort: '',
    page: 0,
    itemLimit: 5,
    workspace: '',
    get url(): string {
      return this.workspace
        ? `/doc?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&start=${this.page}&limit=${this.itemLimit}&workspace=${this.workspace}`
        : `/doc?mode=${this.mode}&filter=${this.filter}&sort=${this.sort}&start=${this.page}&limit=${this.itemLimit}`;
    },
  },
  inviteUsers: {
    get url(): string {
      return '/user/invite';
    },
  },
  creationsSurvey: {
    get url(): string {
      return '/creation/survey';
    },
  },
  selectOrganisation: {
    get url(): string {
      return '/settings/organisation/select';
    },
  },
  convertCreations: {
    get url(): string {
      return '/creation/convert';
    },
  },
  unlockedCreations: {
    start: 0,
    limit: 5,

    get url(): string {
      return `/creation/unlocked?start=${this.start}&limit=${this.limit}`;
    },
  },

  workspaces: {
    creationWorkspace: {
      get url(): string {
        return '/user/workspace';
      },
    },
    userWorkspace: {
      get url(): string {
        return '/workspace';
      },
    },
    updateWorkspace: {
      get url(): string {
        return '/settings/workspace';
      },
    },
    addWorkspaceMember: {
      get url(): string {
        return '/workspace/member';
      },
    },
  },

  task: {
    file: {
      get url(): string {
        return '/board/task/file';
      },
    },
  },
};
